import PropTypes from 'prop-types';
import React from 'react';
import TranslationUtils from 'Utils/TranslationUtils';
import { Helmet } from 'react-helmet';
import c from '../../Components/AuthLayout/authContent.module.less';

const InvalidTokenPage = ({ invalidReason = 'expired' }) => {
  const headerText = TranslationUtils.getText('Oops... ');
  let bodyText = '';
  if (invalidReason === 'expired') {
    bodyText = TranslationUtils.getText('This link has expired. Please request a new one and try again.');
  } else if (invalidReason === 'used') {
    bodyText = TranslationUtils.getText('This link has already been used.');
  } else {
    bodyText = TranslationUtils.getText('This link is no longer valid.');
  }

  return (
    <>
      <Helmet>
        <title>{gettext('Oops...')}</title>
      </Helmet>
      <h1 test-id="page-title" className={c.title}>
        {headerText}
      </h1>
      <p className={c.reason}>{bodyText}</p>
      <p className={c.text}>
        {TranslationUtils.getText('Please')}{' '}
        <a href="mailto:support@pipl.com">{TranslationUtils.getText('contact support ')}</a>
        {TranslationUtils.getText('for further assistance')}
      </p>
    </>
  );
};

InvalidTokenPage.propTypes = {
  invalidReason: PropTypes.string,
};

export default InvalidTokenPage;
